<template>
  <b-col style="margin-top: 10px; font-weight: bold">
    <label for="occurenceDate">{{ this.dateLabel }}</label>
    <br />
    <b-button
      id="setDate"
      @click="pickDate = !pickDate"
      :variant="isValidDate ? 'outline-success' : 'outline-danger'"
    >
      {{ isValidDate ? date : "YYYY-MM-DD" }}
    </b-button>
    <b-form id="occurenceDate" class="dateForm" v-if="pickDate">
      <b-container>
        <b-calendar
          width="300px"
          v-model="date"
          @selected="setDate"
          :max="maxDate"
          locale="de"
        ></b-calendar>
      </b-container>
    </b-form>
  </b-col>
</template>

<script>
import store from "@/store/store.js";
import { DateTime } from "luxon";

export default {
  data() {
    return {
      maxDate: DateTime.now().toFormat("yyyy-MM-dd"),
      pickDate: false,
    };
  },
  computed: {
    date: {
      get() {
        return store.getDate();
      },
      set(date) {
        store.setDate(date);
      },
    },
    isValidDate() {
      return !!store.getDate();
    },
  },
  props: {
    dateLabel: { type: String, default: "" },
  },
  methods: {
    setDate: function () {
      this.pickDate = false;
    },
  },
};
</script>

<style></style>
